import { useState } from 'react';
import ShiftReportFeed from './ShiftReportFeed';
import ShiftReportSheet from './ShiftReportSheet';

/** Self-contained shift-report feed + slide-over, registered as an operation component. */
export default function ShiftReportOperation({ soulId }: { soulId: string }) {
  const [openReportId, setOpenReportId] = useState<string | null>(null);
  return (
    <>
      <ShiftReportFeed soulId={soulId} onOpenReport={setOpenReportId} />
      <ShiftReportSheet
        reportId={openReportId}
        open={!!openReportId}
        onOpenChange={(o) => !o && setOpenReportId(null)}
      />
    </>
  );
}
